import { PaginationResponseBuilder } from './PaginationResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ResultInfoResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('ResultInfo');
    }
    public withTotalActivities = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['totalActivities'] = this.initField(null, args);
        return this;
    }

    public withTotalFilteredActivities = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['totalFilteredActivities'] = this.initField(null, args);
        return this;
    }

    public withPagination = (builder: PaginationResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['pagination'] = this.initField(builder, args);
        return this;
    }

    public withSelectedActivityId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['selectedActivityId'] = this.initField(null, args);
        return this;
    }
}
